// Subtle decorative backdrop: three nodes (UK, AU, NZ) connected by curved
// arcs to express a "unity of entities" feel — not commonwealth iconography.
// All elements are very low opacity so content stays primary.

export const CommonwealthBackdrop = () => (
  <div
    aria-hidden
    className="pointer-events-none absolute inset-0 overflow-hidden"
  >
    {/* Soft radial blue glow, top-right */}
    <div
      className="absolute -right-32 -top-40 h-[640px] w-[640px] rounded-full opacity-60"
      style={{
        background:
          "radial-gradient(closest-side, rgba(47,107,255,0.18), rgba(47,107,255,0.06) 55%, transparent 75%)",
      }}
    />
    {/* Secondary soft glow, bottom-left */}
    <div
      className="absolute -bottom-48 -left-40 h-[560px] w-[560px] rounded-full opacity-50"
      style={{
        background:
          "radial-gradient(closest-side, rgba(47,107,255,0.14), rgba(47,107,255,0.04) 55%, transparent 75%)",
      }}
    />

    {/* Latitude / longitude lines + connecting arcs */}
    <svg
      className="absolute left-1/2 top-[58%] h-[1100px] w-[1600px] -translate-x-1/2 -translate-y-1/2 opacity-[0.22]"
      viewBox="0 0 1600 1100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="arc-grad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#2F6BFF" stopOpacity="0.15" />
          <stop offset="50%" stopColor="#2F6BFF" stopOpacity="0.7" />
          <stop offset="100%" stopColor="#2F6BFF" stopOpacity="0.15" />
        </linearGradient>
        <radialGradient id="node-glow">
          <stop offset="0%" stopColor="#2F6BFF" stopOpacity="0.55" />
          <stop offset="60%" stopColor="#2F6BFF" stopOpacity="0.1" />
          <stop offset="100%" stopColor="#2F6BFF" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Latitudes — faint ellipses */}
      <g stroke="#0A0A0F" strokeOpacity="0.08" fill="none">
        <ellipse cx="800" cy="550" rx="700" ry="120" />
        <ellipse cx="800" cy="550" rx="700" ry="240" />
        <ellipse cx="800" cy="550" rx="700" ry="360" />
        <ellipse cx="800" cy="550" rx="700" ry="460" />
      </g>

      {/* Longitudes */}
      <g stroke="#0A0A0F" strokeOpacity="0.08" fill="none">
        <path d="M100,550 Q800,200 1500,550 Q800,900 100,550 Z" />
        <path d="M260,550 Q800,260 1340,550 Q800,840 260,550 Z" />
        <path d="M430,550 Q800,330 1170,550 Q800,770 430,550 Z" />
        <path d="M600,550 Q800,420 1000,550 Q800,680 600,550 Z" />
      </g>

      {/* Three connecting arcs UK -> AU -> NZ */}
      {/* UK node ~ (560, 360); AU node ~ (1180, 700); NZ node ~ (1380, 760) */}
      <path
        d="M560,360 C720,180 1080,260 1180,700"
        stroke="url(#arc-grad)"
        strokeWidth="1.6"
        fill="none"
        strokeDasharray="4 6"
      />
      <path
        d="M1180,700 C1260,640 1340,700 1380,760"
        stroke="url(#arc-grad)"
        strokeWidth="1.6"
        fill="none"
        strokeDasharray="4 6"
      />
      <path
        d="M560,360 C940,420 1240,560 1380,760"
        stroke="#2F6BFF"
        strokeOpacity="0.18"
        strokeWidth="1"
        fill="none"
      />

      {/* Region nodes */}
      <g>
        {/* UK */}
        <circle cx="560" cy="360" r="44" fill="url(#node-glow)" />
        <circle cx="560" cy="360" r="6" fill="#2F6BFF" />
        <circle cx="560" cy="360" r="11" stroke="#2F6BFF" strokeWidth="1" fill="none" opacity="0.6" />

        {/* AU */}
        <circle cx="1180" cy="700" r="44" fill="url(#node-glow)" />
        <circle cx="1180" cy="700" r="6" fill="#2F6BFF" />
        <circle cx="1180" cy="700" r="11" stroke="#2F6BFF" strokeWidth="1" fill="none" opacity="0.6" />

        {/* NZ */}
        <circle cx="1380" cy="760" r="44" fill="url(#node-glow)" />
        <circle cx="1380" cy="760" r="6" fill="#2F6BFF" />
        <circle cx="1380" cy="760" r="11" stroke="#2F6BFF" strokeWidth="1" fill="none" opacity="0.6" />
      </g>
    </svg>
  </div>
);

export default CommonwealthBackdrop;
